import { Form } from "react-bootstrap"
import { Typeahead } from "react-bootstrap-typeahead"

import TestToBePerform from "../../../../api/LabService/LabServiceModel/TestToBePerform"

interface CHSTestsProps {
  selectedTests: TestToBePerform[]
  availableTests: TestToBePerform[]
  disabled?: boolean
  onChange: (selected: TestToBePerform[]) => void
}

function CHSTests(props: CHSTestsProps) {
  const { selectedTests, availableTests, disabled, onChange } = props

  return (
    <Form.Group>
      <Form.Label className="font-weight-bold required">TEST TO BE PERFORMED</Form.Label>
      <Typeahead
        id="clinicalTestToPerformTypeahead"
        labelKey="Description"
        onChange={onChange}
        options={availableTests}
        isInvalid={selectedTests.length === 0}
        disabled={disabled}
        placeholder="Enter the Test name"
        multiple
        selected={selectedTests}
      />
    </Form.Group>
  )
}

CHSTests.defaultProps = {
  disabled: false,
}

export default CHSTests
